import { Grid, Typography, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { documentIcons } from '../helper';
import { useContext } from 'react';
import { Il8nContext } from '../../../Helper/i18n';

function UploadGrid(props) {
  const { title, proofType, uploaded, isSmallScreen, uploadDocument, onPreview, isRequired, accountOpeningType } = props;
  const localeText = useContext(Il8nContext)

  const { id } = proofType || {};

  return (
    <>
      <Grid container style={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', borderRadius: 10, padding: '15px 0px 15px 0px' }}>
        {
          !isSmallScreen &&
          <Grid item md={2} xs={12} style={{ borderRight: '1px dashed #637FB7', textAlign: 'center' }}>
            <img src={documentIcons[id] || documentIcons['Oth']} alt='proof' />
          </Grid>
        }
        <Grid item md={10} xs={12}>
          <Grid container justifyContent={'space-between'} alignItems={'center'} style={{ height: '100%', paddingLeft: 20 }}>
            <Grid item xs={12} sm={7}>
              <Typography style={{ color: '#0098B0', fontWeight: 'bold' }}>
                {((id?.toLocaleLowerCase() == "ipv") ? "Photograph & IPV" : title) || ''} {isRequired ? '*' : ""}
              </Typography>
              <Typography style={{ color: uploaded ? "#FF6C00" : 'lightgrey', fontSize: 12, fontWeight: 'bold', cursor: uploaded ? 'pointer' : "inherit" }} onClick={uploaded ? onPreview : () => { }}>
                {localeText?.uploadDetailsPreview} {uploaded?.documentName && <span style={{ color:'#525D72',display:'inline-block'}}>({uploaded?.documentName})</span>}
              </Typography>
            </Grid>
              {
                (id?.toLocaleLowerCase() == "photo" && accountOpeningType?.toLocaleLowerCase() != "digi") ?
                <Typography style={{ color: '#A2A2A2', fontSize: 12, marginTop: 5 }}>
                  Auto-updated from IPV.
                </Typography>
                :
                <Grid item xs={12} sm={3} style={isSmallScreen ? { paddingTop: 8 } : { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItem: 'center ' }}>
                    <Button disabled={uploaded} size='small' variant='outlined' onClick={() => uploadDocument(id)}>
                        <>
                          <CloudUploadIcon style={{ marginRight: 5 }} />
                          {localeText?.uploadUp}
                        </>
                    </Button>
                    {isSmallScreen && uploaded && <img style={{ width: "35px" }} src='images/icon_complete-tick.svg' />}
                  </div>
                  <Typography style={{ color: '#A2A2A2', fontSize: 12, marginTop: 5 }}>
                    {(props?.title == "Signature" || props?.title == "Photograph") ? localeText?.uploadDetailsOnlyImg : props?.title == "IPV" ? localeText?.uploadDetailsVideo : localeText?.uploadDetailsImg}
                  </Typography>
                </Grid>
                
              }
            {!isSmallScreen &&
              <Grid item sm={1}>
                {uploaded && <img style={{ width: "60px",paddingRight:"10px" }} src='images/icon_complete-tick.svg' />}
              </Grid>
            }
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default UploadGrid;
